/**
 * Dashboard API — stats and recent registrations
 */
import api from './client'

export function getStats() {
  return api.get('/admin/dashboard/stats')
}

export function getRecent(limit = 8) {
  return api.get('/admin/dashboard/recent', { limit })
}
